import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="company-employee-search"
export default class extends Controller {
  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }
}
